import { LookbackOption, type PersistedDefaultTabProps } from '@talos/kyoko';
import type { TransfersTabProps } from './TransfersBlotter';

export const RECENT_TRANSFERS_TAB_ID = 'recent-transfers';
export const TRANSFERS_TABS_EXCLUDED_IDS = [RECENT_TRANSFERS_TAB_ID];

const recentTransfersTab: PersistedDefaultTabProps<TransfersTabProps> = {
  label: 'Recent',
  id: RECENT_TRANSFERS_TAB_ID,
  closable: false,
  editable: false,
  defaultFilter: {
    _start: LookbackOption.Past30Days,
  },
};

export const DEFAULT_TRANSFERS_TABS: PersistedDefaultTabProps<TransfersTabProps>[] = [recentTransfersTab];

export const NEW_TRANSFER_TAB_DEFAULTS: TransfersTabProps = {
  defaultFilter: {
    _start: LookbackOption.Past30Days,
  },
};
